import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import ToggleCopyForm from '../components/forms/toggle-copy-form/main';
import Table from '../components/table-scaling/main';
import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/fixed-filters/main';
import ContainerNoCopy from '../../shared/no-copy-container';

import { selectors as rootSelectors } from '../../root';
import Switch from '../components/other/switch';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content payout-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Switch {...props}/>
					</div>
				</div>

				<div className="container__content-body">
					<div className="payouts-list__filter-position clearfix">
						<Filters {...props} {...props.filters} />
					</div>

					<div className="ui-control-bar">

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>
						<div className="ui-control-bar__item flex-center margin-0-10">
							<ToggleCopyForm {...props} />
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
									<span>{props.intl('Apply')}</span>
								</button>
							</div>
						</div>
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.download}>
									<span>{props.intl('Download')}</span>
								</button>
							</div>
						</div>
					</div>
					<ContainerNoCopy {...props} tableClass="payout-requests-register-table">
						<Table {...props} />
					</ContainerNoCopy>
				</div>
			</div>
		</Animate>
	),
	'payout_requests_personal_view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		deniedToCopyWords: selectors.getDeniedToCopyWords(state),
		datepicker: selectors.getDatepicker(state),
		isHiddenCopyCols: selectors.getIsHiddenCopyCols(state),
		isRequestFormVisible: selectors.getIsRequestFormVisible(state),
		idOfChangeDateForm: selectors.getIdOfChangeDateForm(state),
		calendar: selectors.getCalendar(state),
		table: selectors.getTable(state),
		sort: selectors.getSortByColumn(state),
		pagination: selectors.getPagination(state),
		can: selectors.getCan(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		requestFormInitialValues: selectors.getRequestFormInitialValues(state),
		filters: selectors.getFilters(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/list-traffic-scaling/main.js